import React from "react";
import {
  withStyles,
  Theme,
  WithStyles,
  createStyles,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "../components/Typography";
import {
  ChatLines,
  Emoji,
  ClockOutline,
  Group,
  CloudSync,
  ShieldCheck,
} from "iconoir-react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    container: {
      marginTop: theme.spacing(8),
      marginBottom: theme.spacing(8),
    },
    title: {
      marginBottom: theme.spacing(6),
    },
    item: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      padding: theme.spacing(0, 3),
    },
    itemTitle: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1),
    },
  });

const features = [
  {
    icon: ChatLines,
    title: "Sync status text",
    description: "Set your status once and it appears in every connected workspace.",
  },
  {
    icon: Emoji,
    title: "Sync status emoji",
    description: "Your status emoji updates across all connected workspaces at the same time.",
  },
  {
    icon: ClockOutline,
    title: "Sync availability",
    description: "Keep your active/away presence consistent everywhere you're signed in.",
  },
  {
    icon: Group,
    title: "Multiple workspaces",
    description: "Connect as many Slack workspaces as you need.",
  },
  {
    icon: CloudSync,
    title: "Automatic synchronization",
    description: "Update once from the app and Dubslack handles pushing the change everywhere.",
  },
  {
    icon: ShieldCheck,
    title: "Secure Slack OAuth",
    description: "Every workspace is connected using Slack's official OAuth authorization flow.",
  },
];

function InstallFeatures(props: WithStyles<typeof styles>) {
  const { classes } = props;

  return (
    <section className={classes.root}>
      <Container className={classes.container}>
        <Typography variant="h4" marked="center" align="center" className={classes.title}>
          Features
        </Typography>
        <Grid container spacing={5}>
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <div className={classes.item}>
                  <Icon color={"#4095D1"} width={"3em"} height={"3em"} />
                  <Typography variant="h6" className={classes.itemTitle}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body1">{feature.description}</Typography>
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </section>
  );
}

export default withStyles(styles)(InstallFeatures);
